import { Button } from '@aon/aon-tws-common-ui';
import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ISurveyQuestionEditModel } from '../../../models';
import { IApplicationState } from '../../../store';
import { ActionCreators } from '../../../store/QuestionChangesStore';

export const UpdateAllButtonContainer = styled.div`
	margin: 20px 0;
	text-align: right;
`;
UpdateAllButtonContainer.displayName = 'UpdateAllButtonContainer';

export interface IQuestionHasUpdatesUpdateAllProps {
	questions: ISurveyQuestionEditModel[];
}
export function QuestionHasUpdatesUpdateAll(props: IQuestionHasUpdatesUpdateAllProps) {
	const dispatch = useDispatch();
	const { isQuestionChangesLoading } = useSelector((state: IApplicationState) => state.questionChanges);

	function UpdateAllQuestions() {
		const { questions } = props;

		const needToUpdateQuestionIds = _.filter(questions, (q) => q.hasUpdates === true && !q.syncWithQuestionLibrary).map(
			(q) => q.surveyQuestionId!,
		);
		if (needToUpdateQuestionIds.length > 0) {
			dispatch(ActionCreators.GetSurveyQuestionChanges(needToUpdateQuestionIds));
		}
	}

	const questionsToBeUpdated = _.filter(props.questions, (q) => q.hasUpdates && !q.syncWithQuestionLibrary);
	return (
		<>
			<UpdateAllButtonContainer>
				<Button color={'secondary'} disabled={questionsToBeUpdated.length === 0 || isQuestionChangesLoading} onClick={UpdateAllQuestions}>
					{ContentConstants.QUESTION_CHANGES_UPDATE_ALL}
				</Button>
			</UpdateAllButtonContainer>
		</>
	);
}
